import { createTheme } from "@mui/material/styles";
import { plPL, enUS } from "@mui/x-data-grid-premium/locales";
import type {} from "@mui/x-data-grid-premium/themeAugmentation";

const theme = (language: string) => createTheme({
  palette: {
    mode: "light",

    primary: {
      main: "#1c6e8c",
      contrastText: "#FFFFFF",
    },

    secondary: {
      main: "#274156",
      contrastText: "#FFFFFF",
    },

    error: {
      main: "#e63946",
    },

    success: {
      main: "#2E7D32",
    },

    warning: {
      main: "#ED6C02",
    },

    info: {
      main: "#1c6e8c",
    },

    background: {
      default: "#F4F7FA",
      paper: "#FFFFFF",
    },

    text: {
      primary: "#1F2937",
      secondary: "#475569",
    },

    divider: "#E2E8F0",

    action: {
      selected: "rgba(28, 110, 140, 0.12)",
      hover: "rgba(28, 110, 140, 0.08)",
    },
  },
  typography: {
    fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,

    h1: { fontSize: "1.75rem", fontWeight: 600 },
    h2: { fontSize: "1.5rem", fontWeight: 600 },
    h3: { fontSize: "1.25rem", fontWeight: 600 },
    h4: { fontSize: "1.1rem", fontWeight: 600 },

    body1: { fontSize: "0.95rem" },
    body2: { fontSize: "0.875rem" },

    button: {
      textTransform: "none",
      fontWeight: 500,
    },
  },

  shape: {
    borderRadius: 8,
  },

  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
        containedPrimary: {
          backgroundColor: "#1c6e8c",
          "&:hover": {
            backgroundColor: "#15566e",
          },
        },
        outlinedPrimary: {
          borderColor: "#1c6e8c",
          color: "#1c6e8c",
          "&:hover": {
            backgroundColor: "rgba(28, 110, 140, 0.08)",
          },
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#1F2937",
          borderBottom: "1px solid #E2E8F0",
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#274156",
          color: "#E5EDF2",
          borderRight: "none",
        },
      },
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "rgba(229, 237, 242, 0.75)",
          minWidth: 36,
        },
      },
    },

    MuiPopper: {
      defaultProps: {
        disablePortal: false,
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#1c6e8c",
            borderWidth: 2,
          },
        },
      },
    },
  },
}, language === "pl" ? plPL : enUS);

export default theme;
